import { useState, useEffect } from "react";

/**
 * @param {React.RefObject<HTMLElement>} element - Ref to observe
 * @param {string} [rootMargin] - IntersectionObserver rootMargin
 * @returns {boolean} Whether the element is intersecting
 */
const useIntersection = (element, rootMargin) => {
    const [isVisible, setState] = useState(false);

    useEffect(() => {
        const currentElement = element?.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                setState(entry.isIntersecting);
            },
            { rootMargin }
        );

        if (currentElement) {
            observer.observe(currentElement);
        }

        return () => {
            if (currentElement) {
                observer.unobserve(currentElement);
            }
        };
    }, [element, rootMargin]);

    return isVisible;
};

export default useIntersection;
